import { IBreadcrumb } from '@/components/common/breadcrumbs';

const breadcrumbListMarkupSchema = (breadcrumbs: IBreadcrumb[]) => {
  const breadcrumbsListItems = breadcrumbs.map((el, index) => {
    return {
      '@type': 'ListItem',
      position: index + 1,
      name: el.title,
      item: `${process.env.NEXT_PUBLIC_SITE_URL}${el.path}`,
    };
  });

  return {
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbsListItems,
  };
};

export default breadcrumbListMarkupSchema;
